export default "__VITE_ASSET__ec185509__"